module.exports = __webpack_public_path__ + "img/imgyongzjq-2.ec5c084a.png";